// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-container[data-v-efce06f8]{display:flex;flex-direction:column;align-items:center;margin-bottom:10px}.main-container .top-panel[data-v-efce06f8]{width:100%;text-align:center}.main-container .main-panel[data-v-efce06f8]{width:80%}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
